module.exports = __webpack_public_path__ + "static/media/bird.d56eb24f.svg";